import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { createStructuredSelector } from 'reselect'
import gearSelection from '../../fieldRenderers/gearSelection'
import { submitFavoriteAmpStep } from '../../actions/userActions'
import { transitionModalLeft, transitionModalRight } from '../../actions/modalActions'
import ArrowBack from '../../images/arrow_back.svg'
import InfoTooltip from '../controls/InfoTooltip'

let InstrumentForm = ({ handleSubmit, skip }) => {
  return (
    <form className="vertical-form" onSubmit={ handleSubmit }>
      <Field name="user[favorite_amp_id]" component={gearSelection} gearType="amp"/>
      <div className="buttons">
        <div className="form-group">
          <input className="continue" name='submit' type='submit' value="Continue"/>
        </div>
        <div className="form-group">
          <input className="skip" name='submit' type='submit' value="Skip" onClick={ skip }/>
        </div>
      </div>
    </form>
  )
}

InstrumentForm = reduxForm({
  form: 'onboarding_pedal_step'
})(InstrumentForm)

InstrumentForm = connect()(InstrumentForm)

const FavoriteAmpStep = ({ back, skip, submit }) => {
  return (
    <div className="favorites-modal">
      <div className="modal-header">
        <div className="back-button" onClick={ back }><ArrowBack/></div>
        <h2>What is your favorite amp that you own?</h2>
        <p>Why do we ask you this?<InfoTooltip>Lorem ipsum dolor sit, consecte tur adipislla cond malesu porem ipsum dolor sit, consectetur adipislla cond lesuada auctor.</InfoTooltip></p>
      </div>
      <InstrumentForm skip={skip} onSubmit={submit}/>
    </div>
  )
}

const selector = createStructuredSelector({
  loginError: state => state.user.loginError
})

const mapDispatchToProps = dispatch => {
  return {
    submit: params => dispatch(submitFavoriteAmpStep(params)),
    back: () => dispatch(transitionModalLeft('FAVORITEPEDALSTEP')),
    skip: () => dispatch(transitionModalRight('WELCOME'))
  }
}

export default connect(selector, mapDispatchToProps)(FavoriteAmpStep)